/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ClickATellForm } from './click-atell-form';
import { MessageBirdForm } from './message-bird-form';
import { TwilioForm } from './twilio-form';

/**
 *
 * @export
 * @interface OtpApiDBI
 */
export class OtpApiDBI {
    /**
     *
     * @type {ClickATellForm | TwilioForm | MessageBirdForm}
     * @memberof OtpApiDBI
     */
    supplierForm?: ClickATellForm | TwilioForm | MessageBirdForm;
    /**
     *
     * @type {string}
     * @memberof OtpApiDBI
     */
    otpSupplier?: OtpApiDBIOtpSupplierEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum OtpApiDBIOtpSupplierEnum {
    Clickatell = 'clickatell',
    Twilio = 'twilio',
    Messagebird = 'messagebird',
}
